/**
 * CMCD Version 2
 *
 * @group CMCD
 *
 * @beta
 */
export const CMCD_V2 = 2;
//# sourceMappingURL=CMCD_V2.js.map